import { Link, useLocation } from "react-router-dom";
import { seoConfig } from "../data/seoConfig";

function MailIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className="h-3.5 w-3.5 shrink-0 fill-none stroke-current"
      focusable="false"
    >
      <path
        d="M3.5 5.5h13v9h-13v-9Zm.5.5 6 4.5L16 6"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function FollowTechniaHQ() {
  const { pathname } = useLocation();
  const locale = pathname.split("/")[1];
  const labels = {
    fr: { reporting: "D’autres articles robotiques avec leurs sources", browse: "Consulter les actualités robotiques", email: "Envoyer un e-mail à TechniaHQRobot" },
    de: { reporting: "Weitere Robotikartikel mit Quellen", browse: "Robotiknachrichten lesen", email: "E-Mail an TechniaHQRobot senden" },
    es: { reporting: "Más artículos de robótica con sus fuentes", browse: "Leer noticias de robótica en inglés", email: "Enviar un correo a TechniaHQRobot" },
    pt: { reporting: "Mais artigos de robótica com fontes", browse: "Ler notícias de robótica em inglês", email: "Enviar e-mail à TechniaHQRobot" },
    ja: { reporting: "出典付きのロボティクス記事を読む", browse: "ロボットニュースを見る", email: "TechniaHQRobotにメールを送る" },
    "zh-cn": { reporting: "阅读更多附有来源的机器人报道", browse: "浏览机器人新闻", email: "向 TechniaHQRobot 发送邮件" },
  }[locale] || { reporting: "More source-linked robotics reporting", browse: "Browse robotics news", email: "Email TechniaHQRobot" };
  const newsLocale = ["fr", "de", "ja", "zh-cn"].includes(locale) ? locale : "en";
  const newsPath = newsLocale === "en" ? "/robotics-news" : `/${newsLocale}/robotics-news`;
  return (
    <aside className="site-wide-section mt-8" aria-label={labels.reporting}>
      <div
        className="site-wide-frame flex flex-col gap-4 border border-white/[0.08] px-5 py-5 text-white shadow-[0_18px_42px_rgba(0,0,0,0.24)] sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-10"
        style={{
          background:
            "radial-gradient(circle at 86% 18%, rgba(37, 99, 235, 0.16), transparent 38%), #08090b"
        }}
      >
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.22em] text-blue-300 sm:text-[11px]">TechniaHQRobot</p>
          <p className="mt-1 text-sm font-bold text-neutral-200">{labels.reporting}</p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <Link to={newsPath} hrefLang={newsLocale === "zh-cn" ? "zh-CN" : newsLocale} className="inline-flex min-h-9 items-center justify-center rounded-full border border-blue-600 bg-blue-600 px-4 py-2 text-xs font-bold text-white transition hover:bg-blue-500">{labels.browse}</Link>
          <a href={`mailto:${seoConfig.email}`} className="inline-flex items-center gap-2 text-xs text-neutral-300 transition hover:text-white" aria-label={`${labels.email} ${seoConfig.email}`}><MailIcon /><span>{seoConfig.email}</span></a>
        </div>
      </div>
    </aside>
  );
}
